import DailyIframe, { DailyCallOptions, DailyCall } from '@daily-co/daily-js'
import * as Sentry from '@sentry/browser'
import * as React from 'react'
import { useRef, useState, useEffect } from 'react'
import styled from '../../../common/src/components/styled'
import { FetchAgentVirtualTourQuery, FetchProspectVirtualTourQuery } from '../../../common/src/types.gen'

const Center = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

interface DailyFrameProps {
  dailyCallOptions:
    | NonNullable<NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>['dailyCallOptions']>
    | NonNullable<FetchProspectVirtualTourQuery['prospectVirtualTour']>['dailyCallOptions']
}

/**
 * React wrapper for daily-js
 */
const DailyFrame = (props: DailyFrameProps) => {
  const { dailyCallOptions } = props
  const { url, token } = dailyCallOptions

  console.log('participant is joining tour', url, ' - token = ', token)

  const ref = useRef<HTMLDivElement>(null)
  const [error, setError] = useState<string | null>(null)
  const [isJoined, setIsJoined] = useState(false)

  useEffect(() => {
    if (isJoined) {
      return
    }

    const options: DailyCallOptions = { url, token }

    if (ref.current == null) {
      return
    }

    const callFrame: DailyCall = DailyIframe.createFrame(ref.current, {
      iframeStyle: {
        position: 'fixed',
        width: '100%',
        height: '100%',
      },
      showLeaveButton: true,
    })

    callFrame.join(options).catch(async err => {
      console.log('[vt] error joining Daily room: ', err)
      setError(err)
      Sentry.captureException(err)
      await Sentry.flush(2000)
    })

    setIsJoined(true)
  }, [ref.current])

  if (error) {
    return <Center>{error}</Center>
  }

  return <div ref={ref} />
}

export default DailyFrame
